import React, { useEffect, useState } from 'react';
import api from '../api/axios';
import { GlobeAmericasIcon, BuildingOfficeIcon, TicketIcon } from '@heroicons/react/24/solid';

const AdminStats = () => {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        api.get('/leaves/admin-stats').then(res => setStats(res.data)).catch(err => console.error(err));
    }, []);

    if (!stats) return <div className="p-4 text-gray-400">Loading Analytics...</div>;

    return (
        <div className="mb-8 animate-fade-in">
            <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                <GlobeAmericasIcon className="h-6 w-6 text-primary mr-2" />
                Daily Snapshot ({new Date().toLocaleDateString()})
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                {/* 1. Location Wise Presence */}
                <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100">
                    <h3 className="text-sm font-bold text-gray-400 uppercase mb-3 flex items-center">
                        <GlobeAmericasIcon className="h-4 w-4 mr-2" /> Workforce Presence
                    </h3>
                    <div className="space-y-3">
                        {stats.locationWise.map(loc => (
                            <div key={loc.country} className="flex justify-between items-center">
                                <div className="flex items-center">
                                    <span className={`w-2 h-2 rounded-full mr-2 ${loc.country === 'India' ? 'bg-orange-500' : loc.country === 'USA' ? 'bg-blue-500' : 'bg-gray-500'}`}></span>
                                    <span className="font-medium text-gray-700">{loc.country}</span>
                                </div>
                                <div className="text-sm">
                                    <span className="font-bold text-green-600">{loc.present}</span>
                                    <span className="text-gray-400"> / {loc.total}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 2. Department Wise Leaves */}
                <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100">
                    <h3 className="text-sm font-bold text-gray-400 uppercase mb-3 flex items-center">
                        <BuildingOfficeIcon className="h-4 w-4 mr-2" /> Absent by Dept
                    </h3>
                    {stats.departmentWise.length === 0 ? <p className="text-sm text-gray-400">100% Attendance today!</p> : (
                        <div className="space-y-3">
                            {stats.departmentWise.map(d => (
                                <div key={d.department} className="flex justify-between items-center border-b border-gray-50 pb-2 last:border-0">
                                    <span className="text-gray-700">{d.department || 'General'}</span>
                                    <span className="bg-red-100 text-red-700 text-xs font-bold px-2 py-1 rounded-full">{d.count}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* 3. Leave Type Breakdown */}
                <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100">
                    <h3 className="text-sm font-bold text-gray-400 uppercase mb-3 flex items-center">
                        <TicketIcon className="h-4 w-4 mr-2" /> Leave Reasons
                    </h3>
                    {stats.typeWise.length === 0 ? <p className="text-sm text-gray-400">No active leaves.</p> : (
                        <div className="space-y-2">
                            {stats.typeWise.map(t => (
                                <div key={t.name} className="flex justify-between text-sm">
                                    <span className="text-gray-600">{t.name}</span>
                                    <span className="font-bold text-gray-800">{t.count}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

            </div>
        </div>
    );
};

export default AdminStats;